export default __webpack_public_path__ + "assets/fanduel-logo.1d439467.png";